export default __webpack_public_path__ + "static/media/alt-close.4e83aabf.svg";